/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVoicemail: {
  name: 'voicemail';
  data: string;
} = {
  name: 'voicemail',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm2.45 5a3.5 3.5 0 1 0-2.45 1h8a3.5 3.5 0 1 0-2.45-1h-3.1Zm5.55 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="currentColor"/></svg>`,
};
